import { makeAutoObservable } from 'mobx'
import { MaintenanceReport } from '../../../ServiceReports/types/maintenance-reports.types'

export type DrawerModeType = 'default' | 'status'
class ServiceReportDetailsDrawerStore {
  report: MaintenanceReport | null = null
  openDrawer: boolean = false
  mode: DrawerModeType = 'default'
  constructor() {
    makeAutoObservable(this)
  }

  setReport = (report: MaintenanceReport) => {
    this.report = report
  }

  setMode = (mode: DrawerModeType) => {
    this.mode = mode
  }

  resetReport = () => {
    this.report = null
    this.mode = 'default'
  }

  setOpenDrawer = (value: boolean) => {
    this.openDrawer = value
  }
}

const serviceReportDetailsDrawerStore = new ServiceReportDetailsDrawerStore()

export default serviceReportDetailsDrawerStore
